<template>
  <div class="page-container">
    <NavBarFSP />
    <div class="page-inner-wrapper">
      <h3 class="table-headline">Edit asset</h3>
      <div class="page-bubble">
        <input type="hidden" v-model="currentAsset.id" class="form-control" />
        <input
          type="hidden"
          v-model="currentAsset.companyCode"
          class="form-control"
          placeholder="companyCode"
          readonly
        />
        <input
          type="hidden"
          v-model="currentAsset.offerCode"
          class="form-control"
          placeholder="offerCode"
          readonly
        />
        <label for="assetType">Asset Type</label>
        <select v-model="currentAsset.assetType" placeholder="Location Code">
          <option value="Generation">Generation</option>
          <option value="Load">Load</option>
          <option value="EV">EV</option>
        </select>
        <label for="assetName">Asset Name</label>
        <input type="text" v-model="currentAsset.assetName" name="assetType" />
        <label for="capacity">Capacity (KWh)</label>
        <input
          type="text"
          v-model="currentAsset.assetCapacity"
          name="assetType"
        />
        <label for="coutnry" class="address-label">Country</label>
        <select
          v-model="currentAsset.assetCountry"
          placeholder="Country"
          class="asset-address"
        >
          <option selected="true" value="country" disabled>
            Select a Country
          </option>
          <option value="AT" label="Austria">Austria</option>
          <option value="BE" label="Belgium">Belgium</option>
          <option value="BG" label="Bulgaria">Bulgaria</option>
          <option value="HR" label="Croatia">Croatia</option>
          <option value="FR" label="France">France</option>
          <option value="DE" label="Germany">Germany</option>
          <option value="GR" label="Greece">Greece</option>
          <option value="HU" label="Hungary">Hungary</option>
          <option value="IT" label="Italy">Italy</option>
          <option value="LU" label="Luxembourg">Luxembourg</option>
          <option value="NL" label="Netherlands">Netherlands</option>
          <option value="PL" label="Poland">Poland</option>
          <option value="PT" label="Portugal">Portugal</option>
          <option value="RO" label="Romania">Romania</option>
          <option value="SE" label="Sweden">Sweden</option>
        </select>
        <label for="address" class="address-label">Address</label>
        <input
          type="text"
          v-model="currentAsset.assetAddress"
          name="assetType"
          class="asset-address"
        />
        <label for="city" class="address-label">City</label>
        <input
          type="text"
          v-model="currentAsset.assetCity"
          name="assetType"
          class="asset-address"
        />
        <label for="postalCode" class="address-label">Postal Code</label>
        <input
          type="text"
          v-model="currentAsset.assetPostCode"
          name="assetType"
          class="asset-address"
        />
        <button type="submit" class="offer-add-button" @click="updateAsset">
          Update
        </button>
        <button class="offer-remove-button" @click="deleteAsset">Delete</button>
        <p>{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AssetDataService from "../../services/AssetDataService";
import NavBarFSP from "../../components/Common/NavBarFSP";

export default {
  name: "asset",
  components: { NavBarFSP },
  data() {
    return {
      currentAsset: {
        id: 1,
        assetType: "Generation",
        assetName: "Generation Asset01",
        assetCapacity: "18",
        assetAddress: "Parklaan 24",
        assetCity: "Sofia",
        assetPostCode: "002744",
        assetCountry: "BG",
      },
      message: "",
    };
  },
  methods: {
    getAsset(id) {
      AssetDataService.get(id)
        .then((response) => {
          this.currentAsset = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updateAsset() {
      AssetDataService.update(this.currentAsset.id, this.currentAsset)
        .then((response) => {
          console.log(response.data);
          this.message = "The asset was updated successfully!";
          this.$router.push({ name: "assets" });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    deleteAsset() {
      AssetDataService.delete(this.currentAsset.id)
        .then((response) => {
          console.log(response.data);
          this.$router.push({ name: "assets" });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.$store.state.auth.user;
    this.message = "";
    this.getAsset(this.$route.params.id);
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.page-inner-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
}

.page-bubble {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
  background: #fff;
  padding: 40px;
  width: 70%;
  margin-right: 40px;
  overflow-x: hidden;
}

.page-bubble label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
}

.page-bubble input,
.page-bubble select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

.page-bubble input:focus,
.page-bubble select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 20px;
  margin-top: 20px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-top: 20px;
}

.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
